export default __webpack_public_path__ + "static/media/project1.42e51ee7.png";